import _ from 'lodash';
import React, {FC} from 'react';
import {connect} from 'react-redux';

import {FrameTypesEnum} from '../../../../../libs/shared/core/src/models/api/apiTypes';
import {getIsUserGlobalAdmin} from '../../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {getHasFluSetupGuide} from '../../../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {ResolveDispatchProps} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {LightUserThemeProvider} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {useAppDispatch, useAppSelector} from '../../../../helpers/appReduxHelpers';
import {updateSelectedSideFrameIdAction} from '../../../../store/data/applications/selectedSideFrameIdActions';
import {useOnboardingModalState} from '../../../app/topBar/onboarding/onboardingContext';
import {useOnboardingFlow} from '../../flow/onboardingFlowHelpers';
import {OnboardingFlowTransitionEnum} from '../../flow/onboardingFlowTypes';
import {OnboardingGuidesEnum} from '../../guide/onboardingGuideTypes';
import {FluGuidePopover} from './fluGuidePopover';

/*
 * Props.
 */

interface WorkflowsGuidePopoverContainerProps {
  panelId: AppPanelId;
}

type WorkflowsGuidePopoverContainerComponentProps = WorkflowsGuidePopoverContainerProps &
  ResolveDispatchProps<typeof mapDispatchToProps>;

/*
 * Component.
 */

const FluGuidePopoverContainerComponent: FC<WorkflowsGuidePopoverContainerComponentProps> = (props) => {
  const {panelId} = props;

  const {renderOnboardingGuideTransition, setOnboardingGuide} = useOnboardingModalState();

  const dispatch = useAppDispatch();
  const {navigateOnboardingFlow} = useOnboardingFlow();

  const isUserGlobalAdmin = useAppSelector(getIsUserGlobalAdmin);
  const hasFluSetupGuide = useAppSelector(getHasFluSetupGuide);

  return renderOnboardingGuideTransition(OnboardingGuidesEnum.FRONT_LINE_USER_WELCOME, (styles) => (
    <LightUserThemeProvider>
      <FluGuidePopover
        styles={styles}
        onComplete={() => {
          setOnboardingGuide(undefined);
          navigateOnboardingFlow(OnboardingFlowTransitionEnum.FLU_GUIDE_COMPLETE);

          if (isUserGlobalAdmin || hasFluSetupGuide) {
            return;
          }

          // Immediately open the P4 start guide for non-admin front line users.
          dispatch(updateSelectedSideFrameIdAction(FrameTypesEnum.START_GUIDE, panelId));
        }}
        onClose={_.noop}
      />
    </LightUserThemeProvider>
  ));
};

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({}));

export const FluGuidePopoverContainer = connect(null, mapDispatchToProps)(FluGuidePopoverContainerComponent);
